//
//
//
//
//
//
//
//
//
//
//
//

import echarts from 'echarts/lib/echarts'
import {
  off,
  on,
} from '@/utils/dom'
import { debounce } from '@/utils/util'

// import echarts from 'echarts'

import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/funnel'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/toolbox'
import 'echarts/lib/component/axisPointer'
import 'echarts/lib/component/visualMap'
import 'echarts/lib/component/markLine'
import 'echarts/lib/component/markPoint'
import 'echarts/lib/component/markArea'
import 'echarts/lib/component/geo'
import 'echarts/lib/component/graphic'
import 'echarts/lib/component/legendScroll'
import { isFunction } from '@/utils/validator'

export default {
  name: 'CECharts',

  props: {
    width: {
      type: [
        String,
        Number,
      ],
      default: '18.75000rem',
    },

    height: {
      type: [
        String,
        Number,
      ],
      default: '18.75000rem',
    },

    apiMethod: Function,

    params: {
      type: Object,
      default: () => ({}),
    },

    resolveEmpty: {
      type: Function,
      default: () => () => false,
    },

    overwrite: {
      type: Boolean,
      default: false,
    },

    options: { type: Object },
  },

  data () {
    return {
      empty: false,
      loading: false,
      handleResize: null,
      myChart: undefined,
    }
  },

  computed: {
    styles () {
      return {
        width: this.width,
        height: this.height,
      }
    },

    hasInit () {
      return !!this.myChart
    },
  },

  watch: {
    options: {
      async handler () {
        this.setOptions()
      },
      deep: true,
    },
  },

  beforeDestroy () {
    off(window, 'resize', this.handleResize)
  },

  mounted () {
    if (!this.hasInit) {
      this.initEChart()
      this.setOptions()
    }
  },

  methods: {
    initEChart () {
      this.myChart = echarts.init(this.$refs.chart)
      this.handleResize = debounce(this.myChart.resize, 200)

      on(window, 'resize', this.handleResize)
    },

    async setOptions () {
      let options = this.options

      if (!options && isFunction(this.apiMethod)) {
        this.loading = true
        options = await this.apiMethod(this.params)
        this.loading = false
        this.empty = this.resolveEmpty(options)
      }

      if (options) {
        if (!this.hasInit) {
          this.initEChart()
        }

        this.myChart.setOption(options, this.overwrite)
      }
    },
  },
}
